enum _PageRoutes {
  Home = '/portal',
  DebitIndex = '/index',
  OpenCard = '/open-card',
  DebitDetail = '/card-detail',
  DebitRight = '/card-right',
  MyCards = '/my-cards',
  BillDetail = '/bill-detail',
  BillList = '/bill-list',
  CardPackage = '/card-package',
  DeleteCardList = '/delete-list',
  ConsumptionReport = '/consumption-report',
  CardManage = '/card-manage',
  CardExpress = '/card-express',
  CardApply = '/card-apply',
  CardInfo = '/card-info',
  SubCardApply = '/sub-card-apply',
  SendSubCard = '/send-sub-card',
  SendSubCardApply = '/change-sub-card-apply',
  BindCard = '/bind-card',
  BindSubCard = '/bind-sub-card',
  QuickBind = '/quick-bind',
  SubCardDetail = '/sub-card-detail',
}

const debitRouteModule = import.meta.env.VITE_DEBIT_CARD_MODULE

export const PageRoutes = !debitRouteModule
  ? _PageRoutes
  : new Proxy(_PageRoutes, {
      get(target, p, receiver) {
        const data: string = Reflect.get(target, p, receiver)
        return `${debitRouteModule}${data}`
      },
    })
